import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { Page404Component } from "./authentication/page404/page404.component";
import { AuthGuard } from "./core/guard/auth.guard";
import { Role } from "./core/models/role";
import { AuthLayoutComponent } from "./layout/app-layout/auth-layout/auth-layout.component";
import { MainLayoutComponent } from "./layout/app-layout/main-layout/main-layout.component";
import { HomePageComponent } from "./home-page/home-page.component";
// import { DashboardComponent } from "./dashboard/dashboard.component";
const routes: Routes = [
  {
    path: "",
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: "", redirectTo: "/authentication/signin", pathMatch: "full" },
      // { path: "tableau-de-bord", component:TableauDeBordComponent },
      { path: "accueil", component:HomePageComponent, canActivate: [AuthGuard] },
      // { path: "dashboard", component:DashboardComponent },
      { path: "dashboard", canActivate: [AuthGuard],
      loadChildren: () =>
        import("./dashboard/dashboard.module").then(
          (m) => m.DashboardModule
        ),
       },
      {
        path: "admin",
        canActivate: [AuthGuard],
        data: {
          role: Role.Admin,
        },
        loadChildren: () =>
          import("./admin/admin.module").then((m) => m.AdminModule),
      },
      {
        path: "editique",
        canActivate: [AuthGuard],
        data: {
          role: Role.Admin,
        },
        loadChildren: () =>
          import("./editique/editique.module").then((m) => m.EditiqueModule),
      },
      {
        path: "audit",
        canActivate: [AuthGuard],
        data: {
          role: Role.Admin,
        },
        loadChildren: () =>
          import("./audit/audit.module").then((m) => m.AuditModule),
      },
      {
        path: "ged",
        canActivate: [AuthGuard],
        data: {
          role: Role.Admin,
        },
        loadChildren: () =>
          import("./ged/ged.module").then((m) => m.GedModule),
      },
      
      {
        path: "parametres",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("./parametres/parametres.module").then(
            (m) => m.ParametresModule
          ),
      },

      {
        path: "production",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("./production/production.module").then(
            (m) => m.ProductionModule
          ),
      },
      {
        path: "prestation",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("./prestation/prestation.module").then(
            (m) => m.PrestationModule
          ),
      },
      {
        path: "sinistre",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("./sinistre/sinistre.module").then(
            (m) => m.SinistreModule
          ),
      },
      {
        path: "comptabilite",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("./comptabilite/comptabilite.module").then(
            (m) => m.ComptabiliteModule
          ),
      },
      {
        path: "administration",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("./administration/administration.module").then(
            (m) => m.AdministrationModule
          ),
      },
      {
        path: "etats",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("./etats/etats.module").then(
            (m) => m.EtatsModule
          ),
      },
      {
        path: "medical",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("./medical/medical.module").then(
            (m) => m.MedicalModule
          ),
      },
    ],
  },
  {
    path: "authentication",
    component: AuthLayoutComponent,
    loadChildren: () =>
      import("./authentication/authentication.module").then(
        (m) => m.AuthenticationModule
      ),
  },
  { path: "**", component: Page404Component },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: "legacy" })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
